module.exports = __webpack_public_path__ + "assets/img/social/facebook-icon.bc773e97f00e6df07cc81fae213b5430.svg";